// App.js
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./AppRouter.tsx";
import { AuthProvider } from "./context/AuthContext.tsx";
import { Provider } from "react-redux";
import store from "./store/store.ts";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <AuthProvider>
      <Provider store={store}>
        <Router>
          <AppRouter />
          <ToastContainer
            position="top-right"
            toastClassName="center-toast"
            progressClassName="progress-toast"
            theme="dark"
          />
        </Router>
      </Provider>
    </AuthProvider>
  );
}

export default App;
